import { jsx as _jsx } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import React from 'react';
const FormError = React.memo(function FormError({ text }) {
    return (_jsx(TextPrimitive, { variant: "tiny", children: _jsx("span", { className: "text-negative-primary", children: text }) }));
});
export default FormError;
//# sourceMappingURL=FormError.js.map